<script>
    import { onMount } from "svelte";
    import { logoutUser } from '/public/services/users/users';
    
    let working = true;

    onMount(() => {
        logoutUser().then(res => {
            if (res.success) {
                working = false;

                window.location = '/';
            }
        });
    });
</script>

<div class="card">
    <div class="card-header">
        Logout
    </div>
    <div class="card-body">

        {#if working === true}
        
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Logging you out...</span>
                </div>
            </div>

        {:else}

            <div class="alert alert-primary clearfix mb-3">
                <h4 class='float-start me-2'>
                    <span class="fas fa-info-circle"></span>
                </h4>
                You have been logged out of the app.
            </div>

        {/if}
        
    </div>
</div>
